import { createTheme } from '@mui/material/styles';
export const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#0073BC',
            light: '#2691CF',
        },
        secondary: {
            main: '#36823F',
            dark: '#216432',
        },
        background: {
            default: '#F7F7FB',
            paper: '#FFFFFF',
        },
    },
    shape: {
        borderRadius: 12,
    },
    typography: {
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
        ].join(','),
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 600,
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
            },
        },
    },
});
